/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsStop: {
  name: 'stop';
  data: string;
} = {
  name: 'stop',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8Zm10 0H8v8h8V8Z" fill="currentColor"/></svg>`,
};
